<template>
  <div class="home">
    <!-- <div class="heeader">
    <HeaderMenu></HeaderMenu>
  </div> -->
    <div class="counts">
      <Search></Search>
      <!-- 地图容器 -->
      <MapView></MapView>
      <Legend></Legend>
      <!-- <MapType></MapType> -->
    </div>
    <div class="sources">
      <div>地图来源：天地图 &nbsp;&nbsp;&nbsp; 审图号：GS（2024）0568号</div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import HeaderMenu from "@/components/HeaderMenu.vue";
import LeftPanel from "@/views/LeftPanel.vue";
import MapView from "@/views/MapView.vue";
import Legend from "./legend.vue";
import MapType from "./MapType.vue";
import Search from "@/components/search/index.vue";

export default {
  name: "index",
  components: {
    HeaderMenu,
    LeftPanel,
    // ToolBar,
    // MapStatus,
    MapView,
    Legend,
    MapType,
    Search,
  },
  props: [],
  data() {
    return {};
  },
  methods: {},
};
</script>
<style lang="less" scoped>
.home {
  width: 100%;
  height: 100%;
  min-width: 1080px;
  min-height: 540px;
}
.counts {
  width: 100%;
  height:100% ;
}
.leftpan {
  position: absolute;
  width: 360px;
  height: calc(100% - 46px);
}

.sources {
  position: absolute;
  bottom: 5px;
  right: 310px;
  width: 340px;
  height: 21px;
  z-index: 10;
  background: rgb(255, 255, 255);
  opacity: 0.75;
  transition: all 0.3s;
  font-size: 12px;
  color: rgb(44, 44, 44);
  padding-left: 10px;
}
</style>
